import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Dialog, Spinner } from '@/components/ui/misc';
import { usePatchTicket } from './tickets-mutations';
import { ClientPicker, type ClientRef } from './ClientPicker';
import { errorMessage } from './ticket-format';

/** Re-parent: move the ticket to another client keeping appointments/comments/history. */
export function ChangeClientDialog({
  ticketNumber,
  currentClientName,
  onClose,
}: {
  ticketNumber: number;
  currentClientName: string;
  onClose: () => void;
}) {
  const patch = usePatchTicket(ticketNumber);
  const [selected, setSelected] = useState<ClientRef | null>(null);
  const [error, setError] = useState<string | null>(null);

  const confirm = () => {
    if (!selected) return;
    setError(null);
    patch.mutate(
      { clientId: selected.id },
      { onSuccess: onClose, onError: (e) => setError(errorMessage(e)) }
    );
  };

  return (
    <Dialog open onClose={onClose} title="Trocar cliente">
      <p className="mb-3 text-sm text-muted-foreground">
        Cliente atual: <span className="font-medium text-foreground">{currentClientName}</span>.
        Apontamentos, comentários e histórico serão mantidos.
      </p>
      <ClientPicker selected={selected} onSelect={setSelected} />
      {error ? <p className="mt-2 text-sm text-destructive">{error}</p> : null}
      <div className="mt-4 flex justify-end gap-2">
        <Button variant="outline" onClick={onClose}>
          Cancelar
        </Button>
        <Button disabled={!selected || patch.isPending} onClick={confirm}>
          {patch.isPending ? <Spinner className="size-4 border-primary-foreground" /> : null}
          Confirmar troca
        </Button>
      </div>
    </Dialog>
  );
}
